/**
 * Layout primitives — thin wrappers around Tamagui stacks.
 * Consumers import these instead of Tamagui directly.
 */
import {
  styled,
  XStack as TamaguiXStack,
  YStack as TamaguiYStack,
  ZStack as TamaguiZStack,
  ScrollView as TamaguiScrollView,
} from 'tamagui'

export const XStack = styled(TamaguiXStack, {
  name: 'XStack',
})

export const YStack = styled(TamaguiYStack, {
  name: 'YStack',
})

export const ZStack = styled(TamaguiZStack, {
  name: 'ZStack',
})

export const ScrollView = styled(TamaguiScrollView, {
  name: 'ScrollView',
})
